export default __webpack_public_path__ + "static/media/asset-8.7bc65700.webp";